var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-xs-12" }, [
    _c("div", { staticClass: "panel panel-default" }, [
      _c("div", { staticClass: "panel-heading" }, [
        _c("div", { staticClass: "ls-flex-row" }, [
          _c("div", { staticClass: "ls-flex-item text-left" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm._f("translate")("Question list")) +
                "\n                "
            )
          ]),
          _vm.$store.state.currentQuestionGroup.gid != null
            ? _c("div", { staticClass: "ls-flex-item text-right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-sm btn-default pull-right clear pjax",
                    attrs: { href: _vm.createQuestionUrl }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm._f("translate")("Create question")) +
                        "\n                    "
                    )
                  ]
                )
              ])
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "panel-body" }, [
        _c("table", { staticClass: "table table-striped" }, [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.columns, function(column) {
                return _c(
                  "th",
                  {
                    key: column.field + "-thead",
                    on: {
                      click: function($event) {
                        return _vm.selectForSort(column)
                      }
                    }
                  },
                  [
                    _c("b", [
                      _vm._v(_vm._s(_vm._f("translate")(column.label)))
                    ]),
                    !column.insortable
                      ? _c("i", {
                          class:
                            _vm.sortBy == column.field
                              ? _vm.sortReverse
                                ? "fa fa-sort-desc"
                                : "fa fa-sort-asc"
                              : "fa fa-sort"
                        })
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ]),
          _c(
            "tbody",
            _vm._l(_vm.sortedQuestionList, function(question) {
              return _c(
                "tr",
                { key: question.qid },
                _vm._l(_vm.columns, function(column) {
                  return _c("td", {
                    key: column.field + "-tbody",
                    domProps: {
                      innerHTML: _vm._s(_vm.getFieldForColumn(column, question))
                    }
                  })
                }),
                0
              )
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }